/**
 * Safari (all platforms) and every iOS / iPadOS browser are built on WebKit,
 * which blocks third-party cookies by default via Intelligent Tracking
 * Prevention. The Google Drive Picker renders a `docs.google.com` iframe that
 * relies on those cookies to resolve the signed-in Google account, so on these
 * browsers it fails to authenticate and shows Google's "Can't access your
 * Google Account" screen (surfaced as a 401 on the picker resource). Chromium
 * based desktop browsers still allow the cookies, so the picker works there.
 *
 * There is no client-side fix — only the user can allow the cookies — so we use
 * this to warn before opening the picker instead of leaving them stuck on
 * Google's raw error. See
 * https://github.com/google/google-api-javascript-client/issues/925
 */
export const isThirdPartyCookieRestrictedBrowser = (
  userAgent: string = typeof navigator === 'undefined' ? '' : navigator.userAgent
): boolean => {
  const isIOS = /iPad|iPhone|iPod/i.test(userAgent);

  const isSafari =
    /safari/i.test(userAgent) &&
    !/chrome|chromium|crios|android|edg|edgios|fxios|opr|opera/i.test(userAgent);

  return isIOS || isSafari;
};
